<template>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h4 class="pt-3">{{ $t('weHaveProblem') }}!</h4>
            <p class="text-muted">{{ $t('pageUnavailable') }}.</p>
          </div>
        </b-col>
      </b-row>
    </div>
</template>

<script>
export default {
  name: 'Page500'
}
</script>
